import { render, staticRenderFns } from "./projectManagementAddDialog.vue?vue&type=template&id=c4ed8a84&scoped=true"
import script from "./projectManagementAddDialog.vue?vue&type=script&lang=js"
export * from "./projectManagementAddDialog.vue?vue&type=script&lang=js"
import style0 from "./projectManagementAddDialog.vue?vue&type=style&index=0&id=c4ed8a84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ed8a84",
  null
  
)

export default component.exports